import Navbar from '../../../components/feature/Navbar';
import Footer from '../../../components/feature/Footer';
import BrandBlogArticlePage from './BrandBlogArticlePage';

export default function BlogArticlePage() {
  return (
    <>
      <Navbar />
      <BrandBlogArticlePage
        publisher="策點文化"
        brandName="策點文化"
        englishName="STRATDOT"
      />
      <Footer />
    </>
  );
}
